import { addDays, differenceInCalendarDays, endOfWeek } from 'date-fns';

const MIN_UPCOMING_DAYS = 5;

/**
 * End of the Mon–Sun week, extended so at least `MIN_UPCOMING_DAYS` remain
 * when near the weekend (used by the calendar events widget and theme
 * earnings "reporting this week").
 */
export const getUpcomingWeekCutoff = (today: Date = new Date()) => {
  let endDate = endOfWeek(today, { weekStartsOn: 1 });
  const daysDifference = differenceInCalendarDays(endDate, today);

  if (daysDifference < MIN_UPCOMING_DAYS) {
    endDate = addDays(endDate, MIN_UPCOMING_DAYS - daysDifference);
  }

  return endDate;
};
